// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"e773a353","579":"96e974d2","584":"d54e5c97","787":"84aef60c","792":"ee1e2d08"}[chunkId] + ".chunk.js";
};